module.exports = require("./yrl-CO.d.ts");